<template>
    <div>
        <div style="padding:10px">
            <div @click="() => {$GlobalStore.closeLastModal()}" style="color:#808080;width:100px;">닫기</div>
        </div>
        <div style="flex:1; padding:12px 12px; display:flex; flex-direction: column">

            <div class="explain_container">
                <div class="title">코치 자격증</div>
                <div class="contents">KFA 인증 지도자 자격증이 있다면</div>
                <div class="contents2">수료증이나 지도자 자격증 카드를 등록하세요</div>
            </div>
            <div style="flex:1;">
                <div style="height:250px; text-align:center;">
                    <img :src="require('@/assets/images/coach_register/coach_regi_cert.png')" style="width:180px;">
                </div>

                <div class="label">KFA 지도자 수료증 / 지도자 자격증 카드</div>
                <div class="file_name" :class="[file0_name ? 'active' : '']">{{file0_name ? file0_name : 'pdf, jpg, jpeg, png 형식으로 제출해 주세요.'}}</div>
                <input type="file" name="file0" id="coach_doc_register_file0" style="display:none;" data-index="0" @change="checkExtension($event)">
                <div v-if="file0_name === ''" class="add_btn" @click="addFile(0)">파일 첨부하기</div>
                <div v-else class="add_btn" @click="deleteFile(0)">파일 삭제하기</div>
            </div>
            <div class="btn_wrap">
                <div class="btn" style="flex:2;" :class="[file0_name ? 'active' : 'inactive']" @click="submit">등록하기</div>
            </div>

        </div>
    </div>
</template>

<script>

    import {FORM_MODE} from "../../../Constants";
    import ResponseCode from "../../../ResponseCode";
    import {COACH_DOC_COMPLETE} from "./CoachDocComplete";

    export default {
        name: "CoachCertRegister",
        props : {

        },
        data(){
            return {
                file0_name : '',
            }
        },
        methods : {
            addFile(index){
                document.getElementById('coach_doc_register_file' + index).click();
            },
            deleteFile(index){
                document.getElementById('coach_doc_register_file' + index).value = '';
                this['file' + index + '_name'] = '';
            },
            checkExtension(e) {
                const input = e.currentTarget;

                if (input.files && input.files[0]) {
                    var extension = input.files[0].name.split('.').pop().toLowerCase();
                    const index = input.getAttribute('data-index');
                    if(extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp'){
                        this['file' + index + '_name'] = input.files[0].name;
                        var reader = new FileReader();
                        reader.onload = (e) => {e;}
                        reader.readAsDataURL(input.files[0]);
                    }else {
                        this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                        this['file' + index + '_name'] = '';
                    }
                }
            },
            async submit(){
                if(!document.getElementById('coach_doc_register_file0').files[0]){
                    this.$GlobalStore.showAlert('수료증/지도자 자격증을 첨부해주세요.');
                    return;
                }

                const formData = new FormData();
                formData.append('mode', FORM_MODE.UPDATE);
                formData.append('file3', document.getElementById('coach_doc_register_file0').files[0]);

                this.$Util.sendEventClick('코치자격증_서류등록');

                this.$GlobalStore.showProgress();
                const res = await this.$Axios.post('/api/player_cert/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                this.$GlobalStore.hideProgress();
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.addModal('CoachDocComplete', {type : COACH_DOC_COMPLETE.CERT_CHANGE_COMPLETE});
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.hideProgress();
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        created(){
            this.submit = this.$Once(this.submit);
        }
    }
</script>

<style scoped>
    .explain_container{padding: 20px;}
    .title{color:#210F03; font-weight:bold; font-size:32px; text-align:center;}
    .contents{color:#210F03; font-size:16px; font-weight:500; text-align:center; margin-top:10px;}
    .contents2{color:#606060; font-size:12px; font-weight:500; margin-top:10px; text-align:center;}
    .label{margin-top:30px; color:#210F03; font-size:16px; font-weight:500; margin-bottom:10px;}
    .file_name{color:#BBBBBB; border-bottom:1px solid #EBEBEB; padding-bottom:8px;}
    .file_name.active{color:#210F03; font-size:16px; font-weight:500;}
    .add_btn{padding:10px 10px; padding-left:0px; display:inline-block; color:#699BF7; font-size:14px; font-weight: bold;}
    .btn_wrap{display:flex; gap: 20px;}
    .btn{flex:1;display:grid; place-items:center; height:46px; border-radius:12px; background-color: #EDEDED; font-size:14px; font-weight:bold;}
    .btn.inactive{color:#D9D9D9; color:#D9D9D9;}
    .btn.active{color:white; background-color:black;}


</style>